<template>
  <article class="team">
    <section class="team__header">
      <div class="container">
        <div class="row">
          <div
            class="col-12 col-md-6 team__header__introduction typography"
          ></div>
          <div class="col-12 col-md-6 team__header__filter">
            <ul
              :class="
                'team__header__filter__list ' +
                  (filter_active ? 'team__header__filter__list--open' : '')
              "
              @click.stop="filter_active = !filter_active"
            >
              <li
                class="team__header__filter__list__item team__header__filter__list__item--first"
              >
                <span>{{ current_filter_title }}</span>
              </li>
              <li
                class="team__header__filter__list__item"
                @click="active_group_index = null"
                v-if="active_group_index !== null"
              >
                Show all
              </li>
              <li
                v-for="(grouping, index) in data.team_grouping"
                :class="filter_item_class(index)"
                @click="active_group_index = index"
                :key="'filter_' + index"
              >
                {{ grouping.category.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="team__main typography">
      <div
        class="container"
        v-for="(grouping, index) in current_groups"
        :key="index"
      >
        <div class="row team__group__title">
          <div class="col-12">
            <h3>{{ grouping.category.name }}</h3>
          </div>
        </div>
        <div class="row team__group__people">
          <div
            class="col-12 col-sm-4 team__group__people__person"
            v-for="(person, person_index) in grouping.team_members"
            :key="'person' + person_index"
          >
            <div class="team__group__people__person__inner">
              <a
                :href="person.link"
                :title="'View ' + person.post_title + 's information'"
              >
                <img
                  :src="person.image"
                  class="team__group__people__person__image"
                  :title="'Photograph of ' + person.post_name"
                />

                <div class="team__group__people__person__content">
                  <p class="team__group__people__person__name large">
                    {{ person.post_title }}
                  </p>
                  <p class="team__group__people__person__job-title small">
                    {{ person.job_title }}
                  </p>
                  <p class="team__group__people__person__linkedin">
                    <a
                      :href="person.linkedin"
                      :title="person.post_title + ' on LinkedIn'"
                      target="linkedin"
                    >
                      <i class="fa fa-linkedin"></i>
                    </a>
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: "TeamPage",
  data: function() {
    return {
      data: window.team_data,
      active_group_index: null,
      filter_active: false
    };
  },
  computed: {
    current_filter_title() {
      if (this.active_group_index === null) {
        return "Show all";
      } else {
        return this.current_groups[0].category.name;
      }
    },
    current_groups() {
      if (this.active_group_index !== null) {
        return [this.data.team_grouping[this.active_group_index]];
      } else {
        return this.data.team_grouping;
      }
    }
  },
  methods: {
    filter_item_class(item_index) {
      let className = "team__header__filter__list__item";
      if (item_index === this.active_group_index) {
        className += " team__header__filter__list__item--active";
      }
      return className;
    }
  }
};
</script>

<style scoped lang="scss">
.team {
  &__header {
    padding: 64px 0;

    @media screen and (max-width: 768px) {
      padding: 17px 0 64px;
    }

    &__filter {
      position: relative;
      display: flex;
      align-items: center;

      &__list {
        margin-left: auto;
        position: absolute;
        right: 16px;
        top: -10px;
        width: 256px;
        background-color: white;

        @media screen and (max-width: 768px) {
          right: initial;
          top: 18px;
          position: absolute;
          z-index: 3;
        }

        &--open {
          box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.1);

          .team__header__filter__list__item {
            display: flex;
          }
        }

        &__item {
          cursor: pointer;
          display: none;
          height: 42px;
          font-size: 14px;
          line-height: 20px;
          font-weight: 600;
          color: #a0a0a0;
          align-items: center;
          justify-content: space-between;
          padding: 0px 7px;

          &--active {
            color: red;
          }

          &--first {
            display: flex;
            border-bottom: 1px solid #dcdcdc;
            height: 31px;
            color: #3c505a;
            justify-content: space-between;
            width: 100%;

            &:after {
              display: block;
              flex: 0 0 6px;
              margin-right: 10px;
              content: "";
              background: {
                image: url("/app/themes/redbeemedia/images/chevron-red-right.svg");
                size: 6px;
                repeat: no-repeat;
                position: center;
              }
              display: block;
              width: 100%;
              height: 100%;
              transform: rotate(270deg);
              transition: transform 0.3s ease-in-out;

              .team__header__filter__list--open & {
                transform: rotate(90deg);
              }
            }

            &:hover,
            &:focus {
              background-color: transparent !important;
              color: #3c505a !important;
            }

            span {
              display: block;
              flex: 0 0 auto;
            }
          }

          &:hover,
          &:focus {
            background-color: #dc281e;
            color: white;
          }
        }

        &__arrow {
        }
      }
    }
  }

  &__main {
    background-color: #f5f5f5;
    padding: 32px 0 64px;

    @media screen and (max-width: 768px) {
      padding: 0;
    }
  }

  &__group {
    &__title {
      padding-top: 32px;

      @media screen and (max-width: 768px) {
        padding-top: 17px;
      }
    }

    &__people {
      &__person {
        margin-bottom: 32px;

        @media screen and (max-width: 768px) {
          margin-bottom: 15px;
        }

        &__inner {
          background-color: white;
        }

        &__image {
          width: 100%;
          height: auto;
          object-fit: cover;
        }

        &__content {
          padding: 24px;
        }

        &__name {
          margin-bottom: 4px !important;
        }

        &__job-title {
          margin-bottom: 32px !important;
        }

        &__linkedin {
          margin-bottom: 0;

          i {
            color: #0077b5;
          }
        }
      }
    }
  }
}
</style>
